import { Action, createReducer, on } from '@ngrx/store';
import { TABLE_INFO } from './app.action';
import { TableInformation, ActionItem } from '@mysrc/models/approval-hub.model';

interface option {
  key: string;
  label: string;
}

interface TableDetailCollection {
  [k: string]: {
    index: number;
    label: string;
    length: number;
    config?: option[];
    metaData?: TableInformation;
    data?: ActionItem[];
  }[];
}

export interface AppState {
  tableDetails: TableDetailCollection;
  activeCategory: string;
  activeSubCategory: string;
}

const initialState: AppState = {
  tableDetails: {},
  activeCategory: '',
  activeSubCategory: '',
};

const featureReducer = createReducer(
  initialState,
  on(TABLE_INFO.tableDetailsSuccess, (state, { data }) => ({
    ...state,
    activeCategory: data[0]?.type,
    activeSubCategory: data[0]?.table_label,
    tableDetails: data.reduce((acc, item, index) => {
      const details = {
        index,
        label: item.table_label,
        metaData: {...item, records: undefined},
        length: item.records?.length || 0,
      };
      if (acc[item.type]) {
        acc[item.type].push(details);
      } else {
        acc[item.type] = [details];
      }
      return acc;
    }, {} as TableDetailCollection),
  })),
  on(TABLE_INFO.fetchConfigSuccess, (state, { data, name }) => ({
    ...state,
    tableDetails: {
      ...state.tableDetails,
      [name || state.activeCategory]: state.tableDetails[name || state.activeCategory].map(
        (v) => {
          const match = data.find(
            (val) => val.tableWholeData.table_label == v.label
          );
          if (match) {
            const config = Object.entries(match.fields).reduce(
              (acc, val) => [...acc, { key: val[0], label: val[1] }],
              [] as option[]
            ).filter(({key})=> key != 'sys_id');
            return {...v, config, data: match.record}
          }
          return v;
        }
      ),
    },
  })),
  on(TABLE_INFO.selectCategory, (state, { name }) => ({
    ...state,
    activeCategory: name,
    activeSubCategory: state.tableDetails[name][0].label
  })),
  on(TABLE_INFO.selectSubCategory, (state, { name }) => ({
    ...state,
    activeSubCategory: name
  }))
);

export function reducer(state: AppState | undefined, action: Action) {
  return featureReducer(state, action);
}
